<template>
    <section class="payment-complete mt-5">
        <div class="container">
            <div class="row px-0">
                <div class="col-sm-12">
                    <div class="text-center">
                        <div class="d-flex justify-content-center" v-if="slotFull">
                            <div class="alert alert-danger bg-white text-center font-sm table-select w-100" role="alert">
                                <small>
                                    {{ $t("Due to high demand, the selected slot is no longer available. Please choose one of the alternative slots below. We apologise for any inconvenience caused") }}
                                </small>
                            </div>
                        </div>

                        <div class="d-flex justify-content-center" v-if="showWarning">
                            <div class="alert alert-danger bg-white text-center font-sm table-select w-100" role="alert">
                                <small>
                                    {{ $t("The products within your shopping cart are not available to be ordered at the new date and time you have now chosen. As a result, your shopping cart will be cleared. Do you want to continue?") }}"
                                </small>
                            </div>
                        </div>

                        <div class="my-3" v-if="slotsAmount">
                            <div class="form-group">
                                <select v-model="currentDay" v-on:change="slotSelectOpened = true" class="w-100 table-select border bg-white" style="font-size: 14px">
                                    <option :value="null">{{ $t("Select a date") }}</option>
                                    <option v-for="(slots, day) in slots" :key="day" :value="day" :disabled="hasDaySlots(day)"> {{ day }}</option>
                                </select>
                            </div>

                            <div class="form-group d-flex justify-content-center" v-if="currentDay">
                                <div class="w-100 table-select text-left border" style="font-size: 14px">
                                    <div class="w-100" v-on:click="slotSelectOpened = !slotSelectOpened">

                                        <span v-if="!currentSlotDetails">{{ $t("Select time") }}</span>
                                        <span v-else-if="slotFormat == 'start_time'">{{ currentSlotDetails.start_at }}</span>
                                        <span v-else-if="slotFormat == 'start_time_end_time'">{{ currentSlotDetails.start_at }} - {{ currentSlotDetails.end_at }}</span>
                                    </div>
                                    <div class="wrapper pt-3 mt-3 border-top" v-if="slotSelectOpened">
                                        <div v-for="slot in currentDateSlots" :key="`slot-${slot.id}`" class="border text-center p-2 cursor-pointer" :class="{
                                            'btn-available-slot': currentSlot != slot.id && isSlotAvailable(slot), 'bg-light text-dark': !isSlotAvailable(slot),
                                            'bg-primary text-white': currentSlot == slot.id && isSlotAvailable(slot)
                                        }" v-on:click="selectSlot(slot)">
                                            <span v-if="slotFormat == 'start_time'">{{ slot.start_at }}</span>
                                            <span v-else-if="slotFormat == 'start_time_end_time'">{{ slot.start_at }}-{{ slot.end_at }}</span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="my-3 text-center font-2xl" v-else-if="fetched">
                            {{ $t("There are no slots available right now. You can switch to eat-in by clicking") }} <span class="font-weight-bold cursor-pointer" v-on:click="switchToEatIn">{{ $t("here") }}</span>.
                        </div>

                        <div class="pb-5 mb-5">
                            <button class="btn btn-reset mr-2" v-on:click="cancel">{{ $t("Cancel") }}</button>

                            <button class="btn btn-click-and-collect ml-2 btn-available-slot" v-on:click="verifySlot" v-if="slotsAmount && !showWarning">
                                {{ $t("Apply") }}
                            </button>

                            <button class="btn btn-primary ml-2" v-on:click="setSlot" v-else-if="showWarning">{{ $t("Continue") }}</button>
                            <button class="btn btn-primary ml-2" v-on:click="switchToEatIn" v-else-if="fetched">{{ $t("Switch to eat-in") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            slots: {},
            order: [],
            fetched: false,
            currentSlot: null,
            slotsAmount: 0,
            showWarning: false,
            siteSlug: this.$route.params.site,
            currentDay: null,
            slotSelectOpened: true,
            slotFull: false,
            slotFormat: window.app.slot_format || 0
        }
    },
    computed: {
        currentSlotDetails() {
            if (!this.currentSlot || !this.currentDay) {
                return null;
            }

            return this.slots[this.currentDay].find(s => s.id == this.currentSlot);
        },
        currentDateSlots() {
            if (!this.currentDay) {
                return [];
            }

            return this.slots[this.currentDay];
        }
    },
    methods: {
        fetch() {
            this.$axios
                .get(`/slots?site=${this.siteSlug}`)
                .then(response => {
                    this.order = response.data.order;
                    this.slots = response.data.items;
                    this.slotsAmount = response.data.slots_amount;

                    // First, try to find the currentDay based on the cart's selected_collect_at date
                    if (window.app.cart && window.app.cart.selected_collect_at) {
                        try {
                            const selectedDate = new Date(window.app.cart.selected_collect_at);
                            
                            // Format to match the backend format: "Friday 25 July"
                            const selectedDateStr = selectedDate.toLocaleDateString('en-GB', {
                                weekday: 'long',
                                day: 'numeric',
                                month: 'long'
                            });
                            
                            // Check if this formatted date exists in our slots
                            if (this.slots[selectedDateStr]) {
                                this.currentDay = selectedDateStr;
                            } else {
                                // Fallback: try different date formatting if the first one doesn't match
                                for (let day in this.slots) {
                                    const dayDate = new Date(day + " " + selectedDate.getFullYear());
                                    if (dayDate.toDateString() === selectedDate.toDateString()) {
                                        this.currentDay = day;
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            console.warn('Could not parse selected_collect_at date:', window.app.cart.selected_collect_at);
                        }
                    }

                    // Fallback: try to find currentDay by matching slot_id (original logic)
                    if (!this.currentDay) {
                        for (let day in this.slots) {
                            for (let slot of this.slots[day]) {
                                if (slot.id == this.currentSlot) {
                                    this.currentDay = day;
                                    break;
                                }
                            }
                            if (this.currentDay) break;
                        }
                    }

                    // Final fallback: default to first available day (original logic)
                    if (!this.currentDay) {
                        for (let day of this.order) {
                            if (this.slots[day].length) {
                                this.currentDay = day;
                                break;
                            }
                        }
                    }
                })
                .catch(error => {
                    this.$toasted.error(this.$t('There are no slots available at the moment.'));

                    this.$modal.hide(this.modalName);
                })
                .finally(response => {
                    this.fetched = true;
                })
        },
        setSlot() {
            const selectedDate = this.parseSelectedDate();

            this.$axios
                .put(`/${this.siteSlug}/slots`, {
                    slot: this.currentSlot,
                    date: selectedDate,
                    clean: this.showWarning
                })
                .then(response => {
                    if (this.$route.query['from-cart'] && !this.showWarning) {
                        window.location = `/${this.siteSlug}/cart`;
                    } else {
                        window.location = `/${this.siteSlug}`;
                    }
                })
                .catch(error => {
                    this.$toasted.error(this.$t('This slot is not available right now. Please select another one.'));

                    this.currentSlot = 0;
                })
        },
        verifySlot() {
            this.showWarning = false;
            const selectedDate = this.parseSelectedDate();

            this.$axios
                .get(`/${this.siteSlug}/slots?slot=${this.currentSlot}&date=${selectedDate}`)
                .then(response => {
                    this.showWarning = response.data.show_warning;

                    if (!this.showWarning) {
                        this.setSlot();
                    }
                })
                .catch(error => {
                    this.$toasted.error(this.$t('This slot is not available right now. Please select another one.'));

                    this.currentSlot = 0;
                })
        },
        switchToEatIn() {
            window.location.href = `/${this.siteSlug}/eat-in`;
        },
        isSlotAvailable(slot) {
            return slot.available && slot.remaining && slot.has_menu;
        },
        selectSlot(slot) {
            if (this.isSlotAvailable(slot)) {
                this.slotSelectOpened = false;
                this.currentSlot = slot.id;
            }
        },
        hasDaySlots(day) {
            return this.slots[day].length == 0;
        },
        cancel() {
            window.history.back();
        },
        parseSelectedDate() {
            // Extract date from currentDay format "Friday 25 July" to "2025-07-25"
            if (!this.currentDay || !this.currentSlotDetails) {
                return null;
            }

            try {
                // currentDay is in format like "Friday 25 July"
                // Need to add the year - but check if it's next year
                const currentYear = new Date().getFullYear();
                const dateStr = this.currentDay + " " + currentYear;
                let parsedDate = new Date(dateStr);

                // If the parsed date is in the past (compare dates only, not time), it's probably next year
                const today = new Date();
                today.setHours(0, 0, 0, 0); // Reset to start of day for fair comparison
                parsedDate.setHours(0, 0, 0, 0); // Reset to start of day for fair comparison
                
                if (parsedDate < today) {
                    parsedDate = new Date(this.currentDay + " " + (currentYear + 1));
                }

                // Use local date formatting to avoid timezone issues
                const year = parsedDate.getFullYear();
                const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
                const day = String(parsedDate.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`; // Format: "2025-07-25"
            } catch (e) {
                console.warn('Could not parse date from currentDay:', this.currentDay);
                return null;
            }
        }
    },
    mounted() {
        if (!window.app.cart) {
            window.location.href = `/${this.siteSlug}`;
        } else {
            this.currentSlot = window.app.cart.slot_id;
        }

        this.fetch();

        this.slotFull = this.$route.query.full == 'true';

        this.$pageTitle = this.$t('Select slot');
    }
}
</script>

<style scoped>
.wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    margin: 0 auto;
    column-gap: 10px;
    row-gap: 10px;
}

.wrapper div {
    padding: 10px;
    background: blue;
    color: #fff;
    text-align: center;
}
</style>
